import { Navigate, useLocation } from "react-router-dom";
const ProtectedRoute = ({ isAuth, children }) => {
  const location = useLocation();
  if (!isAuth.isAuth) {
    return <Navigate to="/signin" replace state={{ from: location }} />;
  } else {
    return children;
  }
};
export default ProtectedRoute;
